import PASentry from "util/pa-sentry";

function yieldAnalyticsEvent(executable) {
  setTimeout(() => {
    try {
      executable();
    } catch (error) {
      error.message = `[${executable.name}] - ${error.message}`;
      error.data = { ...error.data };
      console.log("error.message", error.message);
      console.log("error.data", error.data);
      PASentry.logException(error);
    }
  }, 0);
}

export default yieldAnalyticsEvent;
